import axios from 'axios';
import { ErrorUtils } from '.';
var ApiClient = /** @class */ (function () {
    function ApiClient() {
    }
    ApiClient.prototype.getInstance = function () {
        return axios;
    };
    ApiClient.prototype.get = function (url, config, disableDefaultErrorHandler) {
        return new Promise(function (resolve, reject) {
            axios
                .get(url, config)
                .then(function (response) {
                resolve(response);
            }).catch(function (error) {
                var _a, _b, _c;
                if (!disableDefaultErrorHandler) {
                    try {
                        if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 500) {
                            var errorMessage = ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) || 'An error occurred';
                            ErrorUtils.showErrorModal(errorMessage);
                        }
                    }
                    catch (error) {
                        console.error(error);
                    }
                }
                reject(error);
            });
        });
    };
    ApiClient.prototype.post = function (url, payload, config, disableDefaultErrorHandler) {
        return new Promise(function (resolve, reject) {
            axios
                .post(url, payload, config)
                .then(function (response) {
                resolve(response);
            }).catch(function (error) {
                var _a, _b, _c;
                if (!disableDefaultErrorHandler) {
                    try {
                        if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 500) {
                            var errorMessage = ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) || 'An error occurred';
                            ErrorUtils.showErrorModal(errorMessage);
                        }
                    }
                    catch (error) {
                        console.error(error);
                    }
                }
                reject(error);
            });
        });
    };
    ApiClient.prototype.put = function (url, payload, config, disableDefaultErrorHandler) {
        return new Promise(function (resolve, reject) {
            axios
                .put(url, payload, config)
                .then(function (response) {
                resolve(response);
            }).catch(function (error) {
                var _a, _b, _c;
                if (!disableDefaultErrorHandler) {
                    try {
                        if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 500) {
                            var errorMessage = ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) || 'An error occurred';
                            ErrorUtils.showErrorModal(errorMessage);
                        }
                    }
                    catch (error) {
                        console.error(error);
                    }
                }
                reject(error);
            });
        });
    };
    ApiClient.prototype.patch = function (url, payload, config, disableDefaultErrorHandler) {
        return new Promise(function (resolve, reject) {
            axios
                .patch(url, payload, config)
                .then(function (response) {
                resolve(response);
            }).catch(function (error) {
                var _a, _b, _c;
                if (!disableDefaultErrorHandler) {
                    try {
                        if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 500) {
                            var errorMessage = ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) || 'An error occurred';
                            ErrorUtils.showErrorModal(errorMessage);
                        }
                    }
                    catch (error) {
                        console.error(error);
                    }
                }
                reject(error);
            });
        });
    };
    ApiClient.prototype.delete = function (url, config, disableDefaultErrorHandler) {
        return new Promise(function (resolve, reject) {
            axios
                .delete(url, config)
                .then(function (response) {
                resolve(response);
            }).catch(function (error) {
                var _a, _b, _c;
                if (!disableDefaultErrorHandler) {
                    try {
                        if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 500) {
                            var errorMessage = ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) || 'An error occurred';
                            ErrorUtils.showErrorModal(errorMessage);
                        }
                    }
                    catch (error) {
                        console.error(error);
                    }
                }
                reject(error);
            });
        });
    };
    return ApiClient;
}());
export { ApiClient };
export var apiClient = new ApiClient();
//# sourceMappingURL=api-client.js.map